module.exports = __webpack_public_path__ + "img/Polygon21.94d444cd.png";